import PropTypes from 'prop-types';
import React from 'react';
import SweetAlert from 'sweetalert-react';

const CancelAppointmentModal = ({ isOpen, closeModal, onConfirm }) => (
  <SweetAlert
    show={isOpen}
    title="Cancel Appointment"
    text="Do you really want to cancel this appointment?"
    type="warning"
    confirmButtonColor="#dd6b55"
    confirmButtonText="Yes, cancel appointment"
    cancelButtonText="No"
    onCancel={closeModal}
    onEscapeKey={closeModal}
    onConfirm={onConfirm}
    showCancelButton
  />
);
CancelAppointmentModal.propTypes = {
  isOpen: PropTypes.bool,
  closeModal: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};
CancelAppointmentModal.defaultProps = {
  isOpen: false,
};
export default CancelAppointmentModal;



// WEBPACK FOOTER //
// ./src/app/reservation/components/CancelAppointmentModal.jsx